module.exports = __webpack_public_path__ + "img/union-saint-gilloise-logo-icon.14890566.png";